import React from 'react';
import { Table } from 'react-bootstrap';

import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import TooltipButton from '../common/TooltipButton';

function TooltipAppend({ field }) {
  const { t } = useTranslation();
  return (
    <TooltipButton
      placement="top"
      variant="link"
      text={t(`applications.instantSettlement.form.fields.${field}.tooltipLabel`)}
      className="ms-2 no-underline p-0"
    >
      <i className="sila-icon info text-lg" />
    </TooltipButton>
  );
}

function InstantSettlementForm({ initialValues }) {
  const { t } = useTranslation();

  return (
    <>
      <p className="text-muted">
        {t(
          `applications.instantSettlement.description.${
            initialValues.instant_settlement_status === 'enabled' ? 'enabled1' : 'disabled1'
          }`
        )}
      </p>
      <p className="text-muted">
        {t(
          `applications.instantSettlement.description.${
            initialValues.instant_settlement_status === 'enabled' ? 'enabled2' : 'disabled2'
          }`
        )}
      </p>

      <div className="border rounded mb-1">
        <Table responsive>
          <tbody>
            <tr>
              <td>
                {t('applications.instantSettlement.form.fields.walletUuid.label')}
                <TooltipAppend field="walletUuid" />
              </td>
              {initialValues.crw_wallet_uuid ? (
                <td>{initialValues.crw_wallet_uuid}</td>
              ) : (
                <td className="text-info">{t('common:labels.none')}</td>
              )}
            </tr>
            <tr>
              <td width="50%">
                {t('applications.instantSettlement.form.fields.customerReserveWalletBalance.label')}
                <TooltipAppend field="customerReserveWalletBalance" />
              </td>
              <td>
                <i className="fas fa-dollar-sign" /> {initialValues.crw_wallet_balance || '---'}
              </td>
            </tr>
            <tr>
              <td>
                {t('applications.instantSettlement.form.fields.crwInitialFundingAmount.label')}
                <TooltipAppend field="crwInitialFundingAmount" />
              </td>
              <td>
                <i className="fas fa-dollar-sign" />{' '}
                {initialValues.initial_reserve_balance || '---'}
              </td>
            </tr>
            <tr>
              <td>
                {t('applications.instantSettlement.form.fields.warningBalance.label')}
                <TooltipAppend field="warningBalance" />
              </td>

              <td>
                <i className="fas fa-dollar-sign" /> {initialValues.warning_balance || '---'}
              </td>
            </tr>
            <tr>
              <td>
                {t('applications.instantSettlement.form.fields.minimumBalance.label')}
                <TooltipAppend field="minimumBalance" />
              </td>

              <td>
                <i className="fas fa-dollar-sign" /> {initialValues.minimum_balance || '---'}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
}

InstantSettlementForm.propTypes = {
  /**
   * The values of the form
   */
  // eslint-disable-next-line react/forbid-prop-types
  initialValues: PropTypes.object.isRequired,
};

export default InstantSettlementForm;
